var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 184,
    viewBox: "0 0 185 184",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.975 93.7749C161.975 111.863 154.79 129.21 142 142C129.21 154.79 111.863 161.975 93.7754 161.975C75.6876 161.975 58.3407 154.79 45.5507 142C32.7607 129.21 25.5754 111.863 25.5754 93.7749C25.5754 75.6871 32.7607 58.3402 45.5507 45.5502C58.3407 32.7602 75.6876 25.5749 93.7754 25.5749C100.254 25.5749 106.563 26.5127 112.53 28.2177L125.915 14.8334C116.026 10.7414 105.199 8.5249 93.7754 8.5249C82.5802 8.5249 71.4946 10.73 61.1516 15.0142C50.8086 19.2984 41.4107 25.5779 33.4945 33.4941C17.5071 49.4815 8.52539 71.1652 8.52539 93.7749C8.52539 116.385 17.5071 138.068 33.4945 154.056C41.4107 161.972 50.8086 168.251 61.1516 172.536C71.4946 176.82 82.5802 179.025 93.7754 179.025C116.385 179.025 138.069 170.043 154.056 154.056C170.044 138.068 179.025 116.385 179.025 93.7749H161.975ZM58.9081 77.4069L46.8879 89.5124L85.2504 127.875L170.5 42.6249L158.48 30.5194L85.2504 103.749L58.9081 77.4069Z",
    fill: "#399C54"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.bc0186bb.svg";
export { ForwardRef as ReactComponent };